module.exports = __webpack_public_path__ + "static/master-img1-7f4c0cf8c6e83c7912b023ca785e7d1c.jpg";